// Modul Visitor ID disimpan di cookie "visitor_id" dan expire 2 tahun

export const VisitorID = {
  cookieName: 'visitor_id',
  expiryYears: 2,

  generateRandomString(length) {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  },

  // Buat timestamp string zona waktu Jakarta: DDMMYYhhmmssms
  generateJakartaTimestamp() {
    const now = new Date();

    // Ambil komponen waktu di Asia/Jakarta
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Jakarta',
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(now);

    const get = (type) => parts.find(p => p.type === type)?.value || '00';

    const DD = get('day');
    const MM = get('month');
    const YY = get('year');
    const hh = get('hour');
    const mm = get('minute');
    const ss = get('second');
    const ms = String(now.getMilliseconds()).padStart(3, '0'); // 3 digit

    return `${DD}${MM}${YY}${hh}${mm}${ss}${ms}`;
  },

  generateVisitorID() {
    const timestamp = this.generateJakartaTimestamp(); // contoh: 1012251405105
    const randomString = this.generateRandomString(15);
    return `${timestamp}.${randomString}`;
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  },

  setCookie(name, value, years) {
    const date = new Date();
    date.setTime(date.getTime() + (years * 365 * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  },

  init() {
    let visitorID = this.getCookie(this.cookieName);
    if (!visitorID) {
      visitorID = this.generateVisitorID();
      this.setCookie(this.cookieName, visitorID, this.expiryYears);
      // console.log('New visitor ID:', visitorID);
    }
    return visitorID;
  },

  getVisitorID() {
    return this.getCookie(this.cookieName);
  }
};